// Feature Flags Configuration
// Easy toggles for different features and behaviors

export const FEATURE_FLAGS = {
  // Template Configuration
  // Set to true to make US users see LATAM template (BaseTemplate)
  // Set to false to make US users see Bio Link template (BioLinkTemplate)
  US_USES_LATAM_TEMPLATE: false,
  
  // Spain Template Configuration
  // Set to true to make Spain users see Bio Link template (BioLinkTemplate)
  // Set to false to use BaseTemplate for Spanish users
  SPAIN_USES_BIOLINK_TEMPLATE: true,
  
  // VIP Custom Payments (/vip/:nombre)
  // Set to true to enable VIP custom payments (capacity available)
  // Set to false to show "Capacity Full" message (more exclusive)
  VIP_CUSTOM_PAYMENTS_ENABLED: true,
  
  // VIP Plan Card (BioTemplatePremium & AR Invitacion)
  // Set to true to show VIP plan option (grupo + hablar en privado)
  // Set to false to hide VIP plan card (only show Standard plan)
  VIP_PLAN_CARD_ENABLED: true,
  
  // Other feature flags can be added here
  ENABLE_ANALYTICS: true,
  ENABLE_REGION_DETECTION: true,
  ENABLE_CLOUDFLARE_IMAGES: true,
  
  // Debug flags
  DEBUG_REGION_DETECTION: false,
  DEBUG_TEMPLATE_SELECTION: false,
} as const;

// Helper function to get feature flag value
export const getFeatureFlag = (flagName: keyof typeof FEATURE_FLAGS): boolean => {
  // Check environment variable override first (format: VITE_FF_FLAG_NAME)
  const envVarName = `VITE_FF_${flagName}`;
  const envValue = import.meta.env[envVarName];
  
  if (envValue !== undefined) {
    // Convert string to boolean
    return envValue === 'true' || envValue === '1';
  }
  
  // Return default value from config
  return FEATURE_FLAGS[flagName];
};

// Template selection helpers
export const shouldUSUseLatamTemplate = (): boolean => {
  const flag = getFeatureFlag('US_USES_LATAM_TEMPLATE');
  
  if (getFeatureFlag('DEBUG_TEMPLATE_SELECTION')) {
    // intentional: debug flag checked but logging handled elsewhere
  }

  return flag;
};

export const shouldSpainUseBioLinkTemplate = (): boolean => {
  const flag = getFeatureFlag('SPAIN_USES_BIOLINK_TEMPLATE');

  if (getFeatureFlag('DEBUG_TEMPLATE_SELECTION')) {
    // intentional: debug flag checked but logging handled elsewhere
  }
  
  return flag;
};

// VIP Custom Payments Control (/vip/:nombre)
export const isVipCustomPaymentsEnabled = (): boolean => {
  return getFeatureFlag('VIP_CUSTOM_PAYMENTS_ENABLED');
};

// VIP Plan Card Control (BioTemplatePremium & AR Invitacion)
export const isVipPlanCardEnabled = (): boolean => {
  return getFeatureFlag('VIP_PLAN_CARD_ENABLED');
};

// Export for easy access
export default FEATURE_FLAGS;